// bootstrap.ts exists to guarantee runtime maintenance configuration is ready
// before any React module code executes. This avoids race conditions in UI logic
// that reads window.maintenanceConfig during initial render.
const bootstrap = () => {
  window.loadMaintenanceConfig().then(() => {
    import("./index").catch((error) => {
      console.error("[bootstrap] Failed to load React entry module.", error);
    });
  }).catch((error) => {
    // Fail gracefully: app still starts, but maintenance banner logic will treat config as unavailable.
    console.error("[bootstrap] Failed to preload maintenance config. Starting app without it.", error);
  });
};

bootstrap();

export {};
